import { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./layout.css";

const Layout = ({ children }) => {
  const [isSidebarNarrow, setIsSidebarNarrow] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarNarrow(!isSidebarNarrow);
  };

  return (
    <div className={`app-layout ${isSidebarNarrow ? "sidebar-narrow" : ""}`}>
      <Sidebar isNarrow={isSidebarNarrow} toggleSidebar={toggleSidebar} />
      <div className="main-wrapper">
        <Header toggleSidebar={toggleSidebar} />
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;